import React from 'react'
import { Button } from '@chakra-ui/react'

export default (props) => {
  return <Button {...props} loading={props.loading ?? props.isLoading} />
}
